import { PromptModelTestCase } from '~/features/x-ray/types/deprecated';
import { Uuid } from '~/types/Uuid';

import { DEPRECATED_getPromptModelVersion } from './DEPRECATED_getPromptModelVersion';
import { getPromptModel } from './getPromptModel';

interface Request {
  modelId: Uuid;
  highlightMethod: string;
}

export const getPromptModelOptimizeTestCases = async ({
  modelId,
  highlightMethod,
}: Request): Promise<PromptModelTestCase[]> => {
  const { currentOptimizeInfo } = await getPromptModel({ modelId });

  if (currentOptimizeInfo) {
    const { version } = currentOptimizeInfo;
    const { testCases } = await DEPRECATED_getPromptModelVersion({
      modelId,
      version,
      highlightMethod,
    });
    return testCases;
  }

  return [];
};
